import React from "react";
import { useNavigate } from "react-router-dom";

export default function Verify() {
    const navigate = useNavigate();

    return (
        <div className="flex justify-center min-h-screen bg-[#F7EBFC] px-4 pt-16">
            <div className="flex flex-col items-center w-full max-w-md">
                {/* Logo */}
                <img src="logo.png" alt="Logo" className="max-w-[200px] w-full mb-6" />

                {/* Purple popup box */}
                <div className="bg-[#E3BCF4] p-8 rounded-2xl shadow-xl w-full">
                    <div className="text-purple-800 text-2xl font-bold mb-6 flex items-center justify-center gap-2">
                        <span className="text-3xl">🔞</span> 18Verified
                    </div>

                    <button
                        onClick={() => navigate("/register")}
                        className="bg-[#9B20AC] hover:bg-[#8B1D9A] text-white w-full py-2 rounded-lg font-semibold mb-4 transition"
                    >
                        Get Verified
                    </button>

                    <div className="text-sm text-gray-700 mb-2">Already a member?</div>

                    <button
                        onClick={() => navigate("/login")}
                        className="border border-[#9B20AC] text-[#9B20AC] w-full py-2 rounded-lg font-semibold hover:bg-[#f1d8fc] transition"
                    >
                        Log In
                    </button>
                </div>
            </div>
        </div>
    );
}
